import { useMemo, useState } from "react";

export default function TaskSearch({ tasks, onGoToTask }) {
  const [query, setQuery] = useState("");

  const results = useMemo(() => {
    const q = query.trim().toLowerCase();

    if (q.length < 2) return [];

    return tasks
      .filter((task) => {
        const title = String(task.title || "").toLowerCase();
        const desc = String(task.description || "").toLowerCase();
        const date = String(task.task_date || "").toLowerCase();

        return title.includes(q) || desc.includes(q) || date.includes(q);
      })
      .sort((a, b) => String(a.task_date).localeCompare(String(b.task_date)));
  }, [query, tasks]);

  return (
    <div className="task-search">
      <input
        type="search"
        placeholder="Rechercher une tâche..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      {query.trim().length >= 2 && (
        <div className="task-search-results">
          {results.length === 0 ? (
            <div className="task-search-empty">Aucun résultat</div>
          ) : (
            results.map((task) => (
              <button
                key={task.id}
                type="button"
                className="task-search-result"
                onClick={() => onGoToTask(task)}
              >
                <strong>{task.title || "Sans titre"}</strong>
                <span>{task.task_date}</span>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}